import { campaignGroupCityTags } from '../../services/metaAdsService';

export function splitPrefixedCampaignIds(campaignIds) {
    const meta = [];
    const google = [];
    (campaignIds || []).forEach((id) => {
        const value = String(id || '');
        if (value.startsWith('meta:')) meta.push(value.slice(5));
        else if (value.startsWith('google:')) google.push(value.slice(7));
    });
    return { meta, google };
}

export function primaryCityForUnified(campaign) {
    if (campaign.channel === 'google') {
        return campaign.cities?.[0] || 'Untagged';
    }
    const tags = campaignGroupCityTags(campaign);
    return tags[0] || 'Untagged';
}

/** Sum Meta and Google lead targets per city for the combined (Both) dashboard. */
export function mergeCityTargets(metaTargets = {}, googleTargets = {}) {
    const merged = {};
    const cities = new Set([
        ...Object.keys(metaTargets || {}),
        ...Object.keys(googleTargets || {}),
    ]);
    cities.forEach((city) => {
        const meta = metaTargets[city];
        const google = googleTargets[city];
        if (meta == null && google == null) return;
        merged[city] = (Number(meta) || 0) + (Number(google) || 0);
    });
    return merged;
}

export function mergeUnifiedCampaigns(metaCampaigns, googleCampaigns) {
    const meta = (metaCampaigns || []).map((c) => ({
        ...c,
        channel: 'meta',
        reportingCampaignId: c.campaignId,
        campaignId: `meta:${c.campaignId}`,
    }));
    const google = (googleCampaigns || []).map((c) => ({
        ...c,
        channel: 'google',
        reportingCampaignId: c.campaignId,
        campaignId: `google:${c.campaignId}`,
    }));
    return [...meta, ...google];
}
